<template>
  <div class="space-y-4">
    <div v-for="(skill, index) in modelValue" :key="index" class="p-4 rounded-xl glass-subtle space-y-3">
      <div class="flex gap-2">
        <BaseInput
          :model-value="skill.name"
          label="Skill name"
          class="flex-1"
          @update:modelValue="updateSkill(index, 'name', $event)"
        />
        <BaseButton variant="ghost" type="button" class="self-end text-danger" @click="remove(index)">
          <AppIcon name="Trash2" :size="16" />
        </BaseButton>
      </div>
      <div>
        <label class="text-label block mb-2">Level: {{ skill.level }}%</label>
        <input
          type="range"
          min="0"
          max="100"
          step="5"
          :value="skill.level"
          class="w-full accent-primary"
          @input="updateSkill(index, 'level', Number($event.target.value))"
        />
      </div>
    </div>
    <BaseButton variant="secondary" size="sm" type="button" @click="add">
      <AppIcon name="Plus" :size="16" />
      Add skill
    </BaseButton>
  </div>
</template>

<script>
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import AppIcon from '@/components/ui/AppIcon.vue'

export default {
  name: 'AdminSkillList',
  components: { BaseInput, BaseButton, AppIcon },
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  methods: {
    updateSkill(index, key, value) {
      const next = this.modelValue.map((item, i) => (i === index ? { ...item, [key]: value } : item))
      this.$emit('update:modelValue', next)
    },
    add() {
      this.$emit('update:modelValue', [...this.modelValue, { name: '', level: 50 }])
    },
    remove(index) {
      const next = [...this.modelValue]
      next.splice(index, 1)
      this.$emit('update:modelValue', next)
    },
  },
}
</script>
